import { Link } from "react-router-dom";
import hotSaucesImg from "@/assets/flauriel-hot-sauces.jpg";

const FlaurielTagline = () => {
  return (
    <Link to="/brands/flauriel" className="block relative py-24 overflow-hidden group">
      <img
        src={hotSaucesImg}
        alt="Flauriel Foods"
        loading="lazy"
        width={1280}
        height={864}
        className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
      />
      <div className="absolute inset-0 bg-primary/70 group-hover:bg-primary/60 transition-colors" />
      <div className="relative z-10 container mx-auto px-6 text-center">
        <p className="text-sm uppercase tracking-[0.3em] text-accent font-sans font-semibold mb-4">
          Flauriel
        </p>
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-primary-foreground mb-4">
          Always Fresh! Always Healthy!
        </h2>
        <p className="text-lg text-primary-foreground/90 font-sans italic">
          Holistic Recipes Refined By Four Generations
        </p>
      </div>
    </Link>
  );
};

export default FlaurielTagline;
